<template>
  <div class="manage-feedback">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Danh sách feedback</h3>
      </el-row>
    </el-row>
    <el-form :model="form" inline ref="form">
      <el-form-item>
        <el-input
          v-model="form.name"
          @input="handleSearchFeedback"
          clearable
          placeholder="Tên"
          class="search mb-xl"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.email"
          @input="handleSearchFeedback"
          clearable
          placeholder="Email"
          class="search mb-xl"
        />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="feedbacks" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Tên" width="200px">
        <template slot-scope="scope"> {{ scope.row.fullname }} </template>
      </el-table-column>
      <el-table-column label="Email" width="250px">
        <template slot-scope="scope"> {{ scope.row.email }} </template>
      </el-table-column>
      <el-table-column label="Nội dung">
        <template slot-scope="scope"> {{ scope.row.comment }} </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="callingAPI"
        @current-change="handleChangePage"
        :currentPage="page"
        :pageSize="pageSize"
        :total="total"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchFeedback } from "@/services/feedback";
export default {
  name: "ManageFeedback",
  data() {
    return {
      callingAPI: false,
      debounce: null,

      feedbacks: [],

      page: 1,
      pageSize: 10,
      total: 0,

      form: {
        name: "",
        email: "",
      },
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.$refs.form.resetFields();
      await this.loadData();
    },

    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          name: this.form.name,
          email: this.form.email,
          page: page ? page : 1,
          limit: this.pageSize,
        };
        const response = await fetchFeedback(params);
        this.feedbacks = response.data.feedback;
        this.total = response.data.paginate.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleSearchFeedback() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>
